__turbopack_context__.v({
  "activityTable": "LatestActivity-module-scss-module__nD2-na__activityTable",
  "filterDropdown": "LatestActivity-module-scss-module__nD2-na__filterDropdown",
  "gasIcon": "LatestActivity-module-scss-module__nD2-na__gasIcon",
  "iconBlue": "LatestActivity-module-scss-module__nD2-na__iconBlue",
  "iconDisabled": "LatestActivity-module-scss-module__nD2-na__iconDisabled",
  "iconEnabled": "LatestActivity-module-scss-module__nD2-na__iconEnabled",
  "iconGreen": "LatestActivity-module-scss-module__nD2-na__iconGreen",
  "iconRed": "LatestActivity-module-scss-module__nD2-na__iconRed",
  "iconWhite": "LatestActivity-module-scss-module__nD2-na__iconWhite",
  "latestActivityRow": "LatestActivity-module-scss-module__nD2-na__latestActivityRow",
  "nftImage": "LatestActivity-module-scss-module__nD2-na__nftImage",
  "royalties": "LatestActivity-module-scss-module__nD2-na__royalties",
  "scrollContainer": "LatestActivity-module-scss-module__nD2-na__scrollContainer",
});
